<app-login-layout class="app-dark-theme">
  <main class="reset-password container h-100">
    <div class="row h-100 align-items-center">
      <div class="col-12 col-md-7 offset-md-5 col-lg-5 offset-lg-7">
        <form [formGroup]="data">
          <h2 class="text-center">Set new password</h2>
          <h5 class="text-center mt-5">
            Use the form bellow to change your password
          </h5>

          <div class="mb-3">
            <mat-form-field>
              <input formControlName="password" type="password" matInput placeholder="New Password" />
            </mat-form-field>
          </div>

          <div class="mb-3">
            <mat-form-field>
              <input [errorStateMatcher]="matcher" formControlName="confirmPassword" type="password" matInput
                placeholder="Confirm Password" />
            </mat-form-field>
          </div>

          <div class="mb-3">
            <button [disabled]="!data.valid" (click)="submit()" mat-raised-button color="primary">
              Submit
            </button>
          </div>

          <div class="mb-3">
            <a class="link-color" (click)="goBack()">Back</a>
          </div>

          <div *ngIf="infoMessage" class="row g-2 mt-2 align-items-center">
            <mat-icon class="reset-password__form--icon">error_outline</mat-icon>
            <span class="ms-2" textSize="12">{{ infoMessage }}</span>
          </div>
        </form>
      </div>
    </div>
  </main>
</app-login-layout>